"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CheckboxInput = function CheckboxInput(props) {
  var field = props.field,
    label = props.label,
    tooltip = props.tooltip;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkbox",
    style: {
      margin: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, field, {
    type: "checkbox",
    checked: field.value || false
  })), " ", label, tooltip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement(_question["default"], {
    spaceLeft: true
  }))));
};
CheckboxInput.propTypes = {
  field: _propTypes["default"].object,
  label: _propTypes["default"].node,
  tooltip: _propTypes["default"].node
};
var _default = CheckboxInput;
exports["default"] = _default;